module.exports = __webpack_public_path__ + "static/media/logo.169a3923.png";